(function () {
  'use strict';

  if (window.__hatchillCartDrawerV2Tracking) return;
  window.__hatchillCartDrawerV2Tracking = true;

  var designVersion = 'cart-refinement-20261006';

  // Keep the closed assistant at the screen edge. Its keyboard-aware viewport
  // offset is still used by the open conversation, where the composer needs it.
  function anchorChatLauncher(host) {
    function install() {
      if (!host.isConnected) { observer.disconnect(); return; }
      var root = host.shadowRoot;
      if (!root) return;
      if (root.querySelector('[data-hatchill-launcher-anchor]')) { observer.disconnect(); return; }
      var style = document.createElement('style');
      style.dataset.hatchillLauncherAnchor = 'true';
      style.textContent =
        '.cc-widget[data-live=true][data-open=false]{bottom:max(24px,env(safe-area-inset-bottom),var(--hatchill-launcher-clearance,0px))!important}' +
        '@media(max-width:600px){.cc-widget[data-live=true][data-open=false]{bottom:max(8px,env(safe-area-inset-bottom),var(--hatchill-launcher-clearance,0px))!important}}';
      // Keep the closed assistant in the directory's utility row so
      // neither its icon nor invitation can cover collection links.
      const slot = document.querySelector('.hd-directory--text [data-discovery-chat-slot], .hd-directory--thumbnails [data-discovery-chat-slot]');
      if (slot) {
        style.textContent += '.cc-widget[data-live=true][data-open=false]{position:static!important;left:auto!important;right:auto!important;bottom:auto!important;width:auto!important}.cc-widget[data-live=true][data-open=false] .cc-launcher-text{display:none!important}.cc-widget[data-live=true][data-open=false] .cc-launcher-icon,.cc-widget[data-live=true][data-open=false] .cc-launcher-orb{width:44px;min-width:44px;height:44px;min-height:44px;flex-basis:44px}';
        if (host.parentElement !== slot) slot.appendChild(host);
      }
      root.appendChild(style);
      observer.disconnect();
    }
    var observer = new MutationObserver(install);
    observer.observe(host, { childList: true, attributes: true, attributeFilter: ['data-mounted'] });
    install();
  }

  function findChatLaunchers(root) {
    if (!(root instanceof Element || root instanceof Document)) return;
    if (root instanceof Element && root.matches('[data-chatcast-website]')) anchorChatLauncher(root);
    root.querySelectorAll('[data-chatcast-website]').forEach(anchorChatLauncher);
  }

  findChatLaunchers(document);
  var clearanceFrame;
  var stickyPurchase = document.querySelector('sticky-atc');
  function updateLauncherClearance() {
    clearanceFrame = null;
    var clearance = 0;
    var dock = document.querySelector('hatchill-bottom-nav');
    if (dock) {
      var dockStyle = getComputedStyle(dock);
      var dockRect = dock.getBoundingClientRect();
      var raisedTop = dock.querySelector('.hb-nav__feature')?.getBoundingClientRect().top ?? dockRect.top;
      if (dockStyle.display !== 'none' && dockStyle.visibility !== 'hidden' && dockRect.height > 0 && dockRect.top < window.innerHeight) {
        clearance = Math.ceil(window.innerHeight - Math.min(dockRect.top, raisedTop) + 12);
      }
    }
    if (stickyPurchase?.isConnected) {
      var rect = stickyPurchase.getBoundingClientRect();
      var style = getComputedStyle(stickyPurchase);
      if (rect.height > 0 && rect.top < window.innerHeight && rect.bottom > 0 && style.display !== 'none' && style.visibility !== 'hidden') {
        clearance = Math.ceil(window.innerHeight - Math.max(0, rect.top) + 12);
      }
    }
    // The inline purchase row can meet the launcher before the sticky bar
    // appears. Clear that row only while it occupies the launcher's corner.
    var mainPurchase = document.querySelector('.hatchill-product-page .buy-buttons-block .product-form__submit');
    if (mainPurchase) {
      var mainRect = mainPurchase.getBoundingClientRect();
      var launcherBottom = window.innerHeight - Math.max(clearance, window.innerWidth <= 600 ? 8 : 24);
      if (mainRect.height > 0 && mainRect.top < launcherBottom && mainRect.bottom > launcherBottom - 76) {
        clearance = Math.max(clearance, Math.ceil(window.innerHeight - mainRect.top + 12));
      }
    }
    document.documentElement.style.setProperty('--hatchill-launcher-clearance', clearance + 'px');
  }
  function scheduleClearance() {
    if (!clearanceFrame) clearanceFrame = requestAnimationFrame(updateLauncherClearance);
  }
  var stickyObserver = new MutationObserver(scheduleClearance);
  var stickyResize = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(scheduleClearance) : null;
  function watchStickyPurchase() {
    stickyPurchase?.removeEventListener('transitionend', scheduleClearance);
    stickyPurchase = document.querySelector('sticky-atc');
    stickyObserver.disconnect(); stickyResize?.disconnect();
    if (stickyPurchase) {
      stickyObserver.observe(stickyPurchase, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
      stickyResize?.observe(stickyPurchase);
      stickyPurchase.addEventListener('transitionend', scheduleClearance);
    }
    scheduleClearance();
  }
  watchStickyPurchase();
  window.addEventListener('scroll', scheduleClearance, { passive: true });
  window.addEventListener('resize', scheduleClearance, { passive: true });
  document.addEventListener('hatchill:dock-resize', scheduleClearance);
  document.addEventListener('shopify:section:load', watchStickyPurchase);
  var chatObserver = new MutationObserver(function (records) {
    records.forEach(function (record) {
      record.addedNodes.forEach(function (node) { findChatLaunchers(node); });
    });
  });
  chatObserver.observe(document.body, { childList: true, subtree: true });
  window.addEventListener('pagehide', function () {
    chatObserver.disconnect(); stickyObserver.disconnect(); stickyResize?.disconnect();
    if (clearanceFrame) cancelAnimationFrame(clearanceFrame);
  });
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    chatObserver.observe(document.body, { childList: true, subtree: true });
    findChatLaunchers(document); watchStickyPurchase();
  });


  function getCartState(drawer) {
    var countElement = drawer && drawer.querySelector('.cart-item-count');
    var checkoutButton = drawer && drawer.querySelector('#CartDrawer-Checkout');
    var itemCount = Number.parseInt(countElement && countElement.textContent, 10);
    var cartTotal = Number.parseInt(checkoutButton && checkoutButton.dataset.cartTotal, 10);
    var items = Array.from(drawer.querySelectorAll('[data-meta-product-id]')).map(function (row) {
      var data = row.dataset, quantity = Number(data.metaQuantity), total = Number(data.metaLineTotal);
      return { productId: data.metaProductId, variantId: data.metaVariantId, quantity: quantity, itemPrice: total / 100 / quantity };
    }).filter(function (item) {
      return /^\d+$/.test(item.productId || '') && /^\d+$/.test(item.variantId || '') && Number.isInteger(item.quantity) && item.quantity > 0 && Number.isFinite(item.itemPrice) && item.itemPrice >= 0;
    }).slice(0, 100);

    return {
      surface: 'cart_drawer',
      design_version: designVersion,
      item_count: !drawer.classList.contains('is-empty') && Number.isFinite(itemCount) ? itemCount : 0,
      cart_total: !drawer.classList.contains('is-empty') && Number.isFinite(cartTotal) ? cartTotal : 0,
      items: !drawer.classList.contains('is-empty') ? items : [],
      currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : ''
    };
  }

  function publish(name, properties) {
    var payload = Object.assign({}, properties);

    try {
      if (window.HatchillEvents && typeof window.HatchillEvents.track === 'function') {
        window.HatchillEvents.track(name, payload);
      }
    } catch (error) {}

    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        var published = window.Shopify.analytics.publish('hatchill:' + name, payload);
        if (published && typeof published.catch === 'function') published.catch(function () {});
      }
    } catch (error) {}
  }

  document.addEventListener('cart-drawer:open', function (event) {
    var drawer = (event.detail && event.detail.drawer) || document.querySelector('cart-drawer');
    if (!drawer || !drawer.querySelector('#CartDrawer.hatchill-cart-v2')) return;

    publish('cart_drawer_viewed', getCartState(drawer));
  });

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;

    var checkoutButton = event.target.closest('#CartDrawer.hatchill-cart-v2 #CartDrawer-Checkout');

    if (checkoutButton) {
      publish('cart_drawer_checkout_clicked', getCartState(checkoutButton.closest('cart-drawer')));
      return;
    }

    var progressSummary = event.target.closest('#CartDrawer.hatchill-cart-v2 .hatchill-cart-progress summary');
    if (!progressSummary) return;

    var details = progressSummary.closest('details');
    var drawer = progressSummary.closest('cart-drawer');

    window.setTimeout(function () {
      publish(
        'cart_drawer_try_before_details_toggled',
        Object.assign(getCartState(drawer), {
          expanded: Boolean(details && details.open),
          eligibility_state: details && details.dataset.eligibilityState ? details.dataset.eligibilityState : ''
        })
      );
    }, 0);
  });
})();
